import { labelForWalletMacroCategorySummaryType, ProductMacroCategorySummary } from 'azshared';
import React, { useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { Amount } from '../../../../../../../azshared/src/lib/model/amount';
import { Loader, LoaderSize } from '../../../../../components/loader/loader';
import { AppSvgIcon } from '../../../../../components/svg-icon/app-svg-icon';
import { ProductMacroCategoryCard } from '../product-macro-category-card/product-macro-category-card';
import { TotalAmountCard } from '../total-amount-card/total-amount-card';
import './my-wallet-summary.scss';

const cardSize = 200;
const cardGap = 600;

export interface AppMyWalletSummaryProps {
  totalAmount: Amount;
  flagShowBalance: boolean;
  macroCategorySummary: ProductMacroCategorySummary[];
  isLoading: boolean;
}

export const AppMyWalletSummary = (props: AppMyWalletSummaryProps) => {
  const { totalAmount, flagShowBalance, macroCategorySummary, isLoading } = props;
  const { formatMessage } = useIntl();
  const sliderRef = useRef<Slider>(null);

  const handlePrev = useCallback(() => sliderRef.current?.slickPrev(), [sliderRef]);
  const handleNext = useCallback(() => sliderRef.current?.slickNext(), [sliderRef]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true
  };

  const filteredMacroCategorySummary = macroCategorySummary?.filter((item) => item.amount?.value !== undefined && item.amount.value > 0) || [];

  if (isLoading) {
    return (
      <div className='my-wallet-summary my-wallet-summary-loader'>
        <Loader loadersize={LoaderSize.XL} />
      </div>
    );
  }

  return (
    <div className='my-wallet-summary'>
      <TotalAmountCard total={totalAmount} flagShowBalance={flagShowBalance} />
      <div className='my-wallet-summary-carousel'>
        <Slider ref={sliderRef} {...settings} key={filteredMacroCategorySummary.map((item) => item.type).join('-')}>
          {filteredMacroCategorySummary?.map((item) => (
            <div key={item.type} style={{ width: cardSize, marginRight: cardGap }}>
              <ProductMacroCategoryCard
                title={formatMessage(labelForWalletMacroCategorySummaryType(item.type))}
                amount={item.amount}
                //gain={item.gain} commented for AMA-3586
                flagShowBalance={flagShowBalance}
              />
            </div>
          ))}
        </Slider>
        {filteredMacroCategorySummary.length > 0 && (
          <div className='my-wallet-summary-arrow-buttons'>
            <button onClick={handlePrev}>
              <AppSvgIcon icon={'arrow-left'} />
            </button>
            <button onClick={handleNext}>
              <AppSvgIcon icon={'arrow-right'} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
